import { useTheme } from "@mui/material";
import { ChevronDown } from "lucide-react";
import { type FC, useState } from "react";
import { ContractPickerDrawer } from "web_myplann/Portfolio/Components/Redesign/Documents/ContractPickerDrawer";
import type { LinkableItemOption } from "web_myplann/Portfolio/Types/linkableItemOption";
import { FlatRowInput } from "web_myplann/Shared/Components/FlatRow/FlatRowInput";

type Props = {
	label: string;
	placeholder: string;
	value: LinkableItemOption | null;
	onChange: (value: LinkableItemOption | null) => void;
	options: LinkableItemOption[];
	isLast?: boolean;
};

export const ContractPicker: FC<Props> = ({
	label,
	placeholder,
	value,
	onChange,
	options,
	isLast,
}) => {
	const { palette, iconSize } = useTheme();
	const [open, setOpen] = useState(false);

	return (
		<>
			<FlatRowInput
				label={label}
				placeholder={placeholder}
				value={value?.title ?? ""}
				readOnly
				icon={<ChevronDown size={iconSize.md} color={palette.grey[400]} />}
				onClick={() => setOpen(true)}
				isLast={isLast}
			/>
			<ContractPickerDrawer
				open={open}
				onClose={() => setOpen(false)}
				options={options}
				selectedKey={value?.key ?? null}
				onSelect={(option) => {
					onChange(option);
					setOpen(false);
				}}
			/>
		</>
	);
};
